import { createFileRoute } from '@tanstack/react-router';
import { LiveMatrixScreen } from '@/features/allergens/LiveMatrixScreen';
import { parseMatrixSearch, type MatrixSearch } from '@/features/allergens/lib/search';

/** The Allergens tab opens straight on the matrix (handoff screen 14), All
 *  dishes by default; the controls change ?mode=, ?menuId= and the picks. */
export const Route = createFileRoute('/_app/allergens/')({
  validateSearch: (s: Record<string, unknown>): MatrixSearch => parseMatrixSearch(s),
  component: AllergensRoute,
});

function AllergensRoute() {
  const search = Route.useSearch();
  return <LiveMatrixScreen search={{ ...search, mode: search.mode ?? 'dishes' }} />;
}
